<template>
    <div>
        <div
            v-if="isSidebarExpanded"
            class="modal__overlay"
            @click="closeSidebar"
        >
        </div>
        <PrimaryNavItem
            @click="toggleGamesPageSidebar"
            :selectedItem="{
                name: `${$t(selectedCategory)}`,
            }"
            :isSidebarExpanded="isSidebarExpanded"
        />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import GamesNavigationMixin from '@app/shared/components/Games/GamesNavigationMixin';
    import PrimaryNavItem from '@app/mobile/components/PrimaryNavItem';
    import { SidebarId } from '@app/store/modules/ui/mobile/enums';

    export default {
        mixins: [GamesNavigationMixin],
        computed: {
            ...mapGetters('ui/mobile', ['isSidebarOpen']),
            isSidebarExpanded() {
                return this.isSidebarOpen(SidebarId.gamesNav);
            }
        },
        methods: {
            ...mapActions('ui/mobile', [
                'toggleSidebar',
                'closeSidebar',
            ]),
            toggleGamesPageSidebar() {
                this.toggleSidebar(SidebarId.gamesNav);
            },
        },
        components: {
            PrimaryNavItem,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/mobile/games/GamesSubNav.vue